{
  "version": 1,
  "asset_id": "babb9fb5-62cd-4402-8374-8ef54a34f55d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/babb9fb5-62cd-4402-8374-8ef54a34f55d/beverly-hills-shingle-replacement-in-progress-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/babb9fb5-62cd-4402-8374-8ef54a34f55d/beverly-hills-shingle-replacement-in-progress-768w.avif",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-768w.avif",
  "size": 33453,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:38Z"
}
